namespace $ {
	export function $mol_crypto_uuid(): `${string}-${string}-${string}-${string}-${string}` {
		throw new Error('Unsupported platform')
	}
}
